module.exports = __webpack_public_path__ + "f7a0fd456085b40de556738d6be6ecfd.pdf";